import {Component, EventEmitter, Output, Input} from '@angular/core';

@Component({
  selector: 'app-admin-load-more',
  templateUrl: './admin-load-more.component.html',
  styleUrls: ['./admin-load-more.component.scss']
})
export class AdminLoadMoreComponent {
  @Output() loadMore = new EventEmitter<void>();
  @Input() removeBottomPadding: boolean = false;

  handleClick() {
    this.loadMore.emit();
  }
}
